export default "__VITE_ASSET__86S7OhU8__"